/* eslint-disable quotes */
/**
 * Step Six: Confirmation
 */
/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { Header2, Header3, Text, Button } from '../../../styles/Components'
import { trackBooking,  formatDateLong, formatTimeShort, getArrivalWindow, mq, getAppointmentEndTime } from '../../../helpers'
import Footer from '../../footer'
import { setCode } from '../../../pages/_app'
import _ from 'lodash'
import PhoneNumberInput from '../../phone-number-input'
import { useMe } from '../../../services/GraphQlClientService'
import { sendSms } from '../../../services/sms'
import Image from 'next/image'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore from 'swiper'
import { Navigation, Autoplay, Pagination } from 'swiper/modules'
import PostBookOne from '../../../../public/images/post_book_1.png'
import PostBookTwo from '../../../../public/images/post_book_2.png'
import PostBookThree from '../../../../public/images/post_book_3.png'

const appUrl = 'https://apps.apple.com/us/app/glamsquad/id766676007?ign-mpt=uo%3D4'

const NEXT_PUBLIC_ENVIRONMENT = process.env.NEXT_PUBLIC_ENVIRONMENT
const isDevelopment = NEXT_PUBLIC_ENVIRONMENT === 'development'

const ConfirmationContainer = styled.div`
  margin-top: 92px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mq('max', '768px')} {
    margin-top: 38px;

    h2 {
      margin-bottom: 12px;
    }
  }

  .appointment-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 40px;

    ${mq('max', '768px')} {
      width: 100%;
      padding: 0 16px;
      gap: 30px;
    }

    .appointment-detail {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      width: 100%;

      img {
        margin-right: 18px;
      }

      .summary-detail {
        display: flex;
        flex-direction: column;
        justify-content: center;

        p {
          ${mq('max', '768px')} {
            font-size: 16px;
          }
        }

        .arrival-window-text {
          margin-top: 5px;
          font-family: Euclid;
          max-width: 350px;
        }
      }
    }
  }

  .confirmation-info-text {
    max-width: 624px;
    text-align: center;

    ${mq('max', '768px')} {
      margin: 35px 0;
      width: 100%;
      max-width: none;
      padding: 0 16px;
      text-align: left;
    }
  }

  .app-download-cta {
    width: 100%;
    background-color: #F9F4EE;
    display: flex;
    flex-direction: row;
    max-width: 1600px;

    ${mq('max', '700px')} {
      flex-direction: column;
    }


    .cta-input-container {
      flex-basis: 50%;
      ${mq('max', '768px')} {
        // flex-basis: 100%;
      }

      ${mq('max', '700px')} {
        flex-basis: 100%;
      }

      .cta-content {
        padding: 50px 10px 50px 80px;
        display: flex;
        flex-direction: column;

        ${mq('max', '768px')} {
          padding: 50px 16px 50px 16px;
        }

        .cta-info-text {
          max-width: 550px;
        }

        ${mq('max', '700px')} {
          max-width: 100%;
          padding-bottom: 0;
          .cta-info-text {
            margin-bottom: 10px;
          }

          .phone-input-container {
            display: none;
          }
          
        }

        .phone-input-container {
          max-width: 480px;
          
          .phone-input {
            padding: 10px 10px 0 10px;
            background-color: #fff;
            border: 1px solid #adadad;

            .PhoneInputCountry {
              border: none;
            }

            input {
              border: none !important;
            }
          }
          
        }

        .app-store-icon-container {
          position: relative;
          margin-top: 50px;
          height: 80px;
          width: 200px;

          ${mq('max', '700px')} {
            margin: 0;
          }
        }
      }
    }

    .app-image-container {
      display: flex;
      flex-basis: 50%;
      position: relative;

      ${mq('max', '950px')} {
        flex-basis: 70%;
      }

      ${mq('max', '700px')} {
        width: 100%;
      }

      img {
        object-fit: cover;

        ${mq('max', '700px')} {
          position: relative !important;
        }
      }
    }
  }

  .post-book-carousel {
    padding: 50px 88px;
    width: 100%;
    max-width: 1600px;

    ${mq('max', '768px')} {
      padding: 50px 16px;
    }

    .swiper-slide {
      height: auto;
    }

    .swiper-wrapper {
      display: flex;
      height: 100%;
    }
  
    .swiper-pagination {
      margin-top: 50px;
      position: relative;
      text-align: left;
      display: none;

      ${mq('max', '768px')} {
        display: block;
      }
    }

    .swiper-pagination-bullet {
      height: 12px;
      width: 12px;
      border-radius: 50%;
      background-color: transparent;
      border: 1px solid #3f3f3f;
      bottom: 0;
    }
    
    .swiper-pagination-bullet-active {
      height: 12px;
      width: 12px;
      border-radius: 50%;
      background-color: #000;
      border: 1px solid #000;
    }
  }
  }
  
`

const Six = ({ state, appDispatch }) => {
  const {
    bookedAppointment,
    isNewUser,
    appliedPromoCode,
    appliedPromoCodeAmt,
    marketServicesForMarket,
    serviceRequests,    
    market,
  } = state

  SwiperCore.use([Pagination, Autoplay, Navigation])
  const { timezone } = market

  const me = useMe()
  const [smsInput, setSMSInput] = useState('')
  const [working, setWorking] = useState(false)
  const [smsSent, setSmsSent] = useState(false)

  const handlePhoneInput = (input) => {
    setSMSInput(input)
  }

  const handleSendSMS = async () => {
    try {
      setWorking(true)
      await sendSms(smsInput)
      setSmsSent(true)
    } catch (error) {
      console.error(error)
    } finally {
      setWorking(false)
    }
  }

  useEffect(() => {
    if (!me) {
      return
    }
    // track booking event
    trackBooking(
      bookedAppointment,
      isNewUser,
      appliedPromoCode,
      appliedPromoCodeAmt,
      marketServicesForMarket,
      serviceRequests,
      market,
      me
    )

    setSMSInput(me?.phone)
  }, [appliedPromoCode, appliedPromoCodeAmt, bookedAppointment, isNewUser, marketServicesForMarket, 
    serviceRequests, market, me])
  
  useEffect(() => {
    return () => {
      appDispatch(setCode(null))
    }
  }, [appDispatch])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const arrivalWindow = getArrivalWindow(bookedAppointment.actualStartDateTime, timezone)
  const appointmentEndTime = getAppointmentEndTime(bookedAppointment, timezone)
  
  const team = _.chain(bookedAppointment?.appointmentServices || [])
    .map('providerId')
    .uniq()
    .value()
    .length || 1

  return (
    <div style={{ height: '100vh' }}>
      <ConfirmationContainer>
        <Header2
          lineHeight="138%"
          spacing={0.46}
          align="center"
          margin="0 0 20px"
        >
          See you soon!
        </Header2>
        <Header3
          margin="0 0 38px"
          fontSize={22}
          weight={500}
          lineHeight="138%"
          spacing={0.88}
          align="center"
        >
          You&apos;re booked for:
        </Header3>
        <div className="appointment-container">
          <div className="appointment-detail">
            <img src="/images/booking-checkout-calendar.svg" alt="date" />
            <div className="summary-detail">
              <Text fontSize={18} weight={600} lineHeight="140%">
                {formatDateLong(
                  bookedAppointment.actualStartDateTime,
                  timezone
                )}
                &nbsp;
                {formatTimeShort(
                  bookedAppointment.actualStartDateTime,
                  timezone
                )}
                &nbsp;-&nbsp;
                {appointmentEndTime}
              </Text>

              <div className='arrival-window-text'>
                <Text fontSize={16} weight={400}>
                  Your Beauty Pro{team > 1 ? 's' : ''} will arrive between <b>{arrivalWindow?.[0]}</b> and <b>{arrivalWindow?.[1]}</b>
                  &nbsp;to start the appointment and will finish by <b>{appointmentEndTime}</b>
                </Text>
              </div>
            </div>
          </div>
          <div className="appointment-detail">
            <img src="/images/booking-checkout-time.svg" alt="date" />
            <div className="summary-detail">
              <Text fontSize={18} weight={600} lineHeight="140%">
                {bookedAppointment.address.street}
              </Text>
              {bookedAppointment.address.apartment && (
                <Text fontSize={18} weight={600} lineHeight="140%">
                  {bookedAppointment.address.apartment}
                </Text>
              )}
              <Text fontSize={18} weight={600} lineHeight="140%">
                {bookedAppointment.address.city},{' '}
                {bookedAppointment.address.state}{' '}
                {bookedAppointment.address.zip}
              </Text>
            </div>
          </div>
        </div>
        <Text
          fontSize={22}
          variant="medium"
          lineHeight="138%"
          spacing={0.88}
          margin="80px 0 104px"
          className="confirmation-info-text"
        >
          Your confirmation email is on the way. In the meantime, 
          download our app and check out our tips for how to prep for your appointment.
        </Text>
        <div className='app-download-cta'>
          <div className='cta-input-container'>
            <div className='cta-content'>
              <Header2
                margin='0 0 25px 0'
              >
                GET REAL<br/> TIME UPDATES
              </Header2>
              <Text
                fontSize={22}
                margin='0 0 50px 0'
                className='cta-info-text'
              >
                Directly message pros, track ETAs and gain access
                to exclusive offers all on the Glamsquad app.
              </Text>


              <div className='phone-input-container'>
                <PhoneNumberInput
                  className='phone-input'
                  autoComplete='tel'
                  value={smsInput}
                  onChange={handlePhoneInput}
                  state={{ value: smsInput || '' }}
                />
                <Text margin='12px 0' fontSize={12}>
                  By continuing you consent to receive text messages from Glamsquad. Message & data rates may apply.
                </Text>
                <Button
                  onClick={handleSendSMS}
                  fill
                  large
                  color='#000'
                  disabled={working || smsSent}
                >
                  { smsSent ? 'Link Sent' : 'Send Me a Link'}
                </Button>
              </div>

              <div className='app-store-icon-container'>
                <a
                  href={appUrl}
                  target='_blank'
                  rel='noreferrer'
                >
                  <Image
                    src='/images/download_on_app_store.svg'
                    alt='app-store-download' 
                    fill
                  />
                </a>
              </div>
            </div>
          </div>
          <div className='app-image-container'>
            <Image
              quality={100}
              src='/images/app_download.png'
              alt='glamsquad-app' 
              style={{
                width: '100%',
              }}
              fill
              priority
            />
          </div>
        </div>

        <div className='post-book-carousel'>
          <Swiper
            slidesPerView={1.25}
            spaceBetween={10}
            breakpoints={{
              768: {
                slidesPerView: 3,
                spaceBetween: 16
              }
            }}
            pagination={{ clickable: true, dynamicBullets: false }}
          >
            <SwiperSlide>
              <PostBookSlide 
                src={PostBookOne}
                title='Find inspo photos'
                body='Save pictures of looks you love to show your pros exactly what you want.'
              />
            </SwiperSlide>
            <SwiperSlide>
              <PostBookSlide 
                src={PostBookTwo}
                title='Line up your faves'
                body='We’ll bring plenty of products - but if you’ve got favourites at home, we can use those, too.'
              />
            </SwiperSlide>
            <SwiperSlide>
              <PostBookSlide 
                src={PostBookThree}
                title='Wash before your blowout'
                body='Shampoo your hair shortly before we arrive, so it’s damp and blowout-ready.'
              />
            </SwiperSlide>
          </Swiper>
        </div>

      </ConfirmationContainer>
      <Footer forceShow={true} />
      {!isDevelopment ? (
        <img
          src={`https://www.shareasale.com/sale.cfm?tracking=${bookedAppointment.id}&amount=${bookedAppointment.finalPrice}&merchantID=138044&transtype=sale`}
          width="1"
          height="1"
          alt="share-a-sale pixel"
        />
      ) : null}
    </div>
  )
}

const PostBookSlideContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  .slide-image-container {
    position: relative;
    width: 100%;
    height: 600px;
  }

  .slide-body {
    flex-grow: 1;
    margin-bottom: 50px;
  }

  .slide-title {
    margin-bottom: 12px;
  }
`

const PostBookSlide = ({ src, title, body }) => {
  return (
    <PostBookSlideContainer>
      <Text weight={800} className='slide-title'>{title}</Text>
      <Text className='slide-body'>{body}</Text>

      <div className='slide-image-container'>
        <Image 
          alt={title}
          quality={100}
          src={src}
          fill
          style={{
            objectFit: 'cover',
          }}
        />
      </div>
    </PostBookSlideContainer>
  )
}

Six.propTypes = {
  state: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  setIsStepValid: PropTypes.func.isRequired,
}

export default Six
